/**
 * Single source of truth for extraction-confidence bucketing, per the product
 * spec's suggested bands (>=0.90 high, 0.70-0.89 medium, <0.70 low). Nothing
 * else in the codebase should hardcode a confidence threshold — import from
 * here so the bands stay consistent and easy to tune in one place.
 */
export const CONFIDENCE_THRESHOLDS = {
  /** At or above this, a field is shown as high-confidence ("ok"). */
  ok: 0.9,
  /** At or above this (but below `ok`), a field is medium-confidence. Below it, low. */
  lowConfidence: 0.7,
} as const;

export type ConfidenceBand = 'high' | 'medium' | 'low';

export function bandForConfidence(confidence: number): ConfidenceBand {
  if (confidence >= CONFIDENCE_THRESHOLDS.ok) return 'high';
  if (confidence >= CONFIDENCE_THRESHOLDS.lowConfidence) return 'medium';
  return 'low';
}
